import { useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import CreateTeamSteps from './CreateTeamSteps';
import { Dialog } from '@mui/material';
import NextBackButtonGroup from './NextBackButtonGroup';
import useStripeAccount from '@hooks/useStripeAccount';
import { TeamForm, getDefaultNewTeam, newTeamSchema } from './CreateTeamUtils';
import useUser from '@hooks/useUser';

interface Props {
    onClose: () => void;
    showModal: boolean;
}

export default function CreateTeamModal({ onClose, showModal }: Props) {
    const [currentStep, setCurrentStep] = useState(0);
    const onNextClick = () => {
        setCurrentStep(currentStep + 1);
    };
    const currentUser = useUser();
    const { stripeInfo } = useStripeAccount();
    const defaultValues: Partial<TeamForm> = useMemo(
        () => getDefaultNewTeam(undefined, stripeInfo?.detailsSubmitted, currentUser.user?.id),
        [currentUser.user?.id, stripeInfo?.detailsSubmitted],
    );
    const formMethods = useForm<TeamForm>({
        defaultValues,
        mode: 'all',
        resolver: yupResolver(newTeamSchema),
    });

    // onPrevClick decrements the page by 1 unless we are already at page 0
    const onPrevClick = () => {
        const prevPage = Math.max(0, currentStep - 1);
        setCurrentStep(prevPage);
    };

    return (
        <FormProvider {...formMethods}>
            <form>
                <Dialog fullWidth maxWidth="md" sx={{ height: '90%' }} open={showModal}>
                    <CreateTeamSteps step={currentStep} />
                    <NextBackButtonGroup
                        step={currentStep}
                        onClose={onClose}
                        onPrevClick={onPrevClick}
                        onNextClick={onNextClick}
                    />
                </Dialog>
            </form>
        </FormProvider>
    );
}
